<div class="container bg-white mt-3 shadow-sm p-4">
  <h2>New Ledger Adjustments</h2>
  <hr />
  <div class="row">
    <div class="col-md-6">
      <div class="card shadow-sm">
        <div class="card-body">
          <h5 class="card-title mb-0">
            <a href="#" (click)="$event.preventDefault(); $event.stopPropagation(); toggleNewAdjustment()"> <i class="fas" [ngClass]="{ 'fa-plus-circle': !showNewForm, 'fa-minus-circle': showNewForm }"></i>&nbsp;New Adjustment </a>
          </h5>
          <form #currentform="ngForm" novalidate *ngIf="showNewForm">
            <app-ledger-adjustment-form [ledger]="newLedger"></app-ledger-adjustment-form>
            <div class="form-group text-center">
              <button type="button" class="btn btn-primary" (click)="addAdjustment(currentform)">Add</button>
              &nbsp;
              <button type="button" class="btn btn-outline-secondary" (click)="showNewForm = false">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <h4 class="pt-5">
    Adjustments to be created &nbsp;
    <small>
      <app-badge badgeType="primary">
        {{ ledgersToAdjust.length }}
      </app-badge>
    </small>
  </h4>
  <div class="text-muted text-center py-5 px-3" *ngIf="ledgersToAdjust.length < 1">No Ledger Adjustments Entered</div>
  <div class="pt-3" *ngIf="ledgersToAdjust.length > 0">
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th>Date</th>
          <th>Account</th>
          <th>Description</th>
          <th>Credit</th>
          <th>Debit</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let ledger of ledgersToAdjust; let i = index">
          <td *ngIf="!ledger.editing">
            <a style="text-decoration: none !important" href="#" (click)="$event.preventDefault(); $event.stopPropagation(); editAdjustment(ledger)">
              <i class="fas fa-pencil-alt"></i>
            </a>
            |
            <a style="text-decoration: none !important" class="text-danger" href="#" (click)="$event.preventDefault(); $event.stopPropagation(); removeAdjustment(i)">
              <i class="fas fa-trash"></i>
            </a>
          </td>
          <td *ngIf="!ledger.editing">{{ ledger.created_at_str }}</td>
          <td *ngIf="!ledger.editing">{{ ledger.chart_of_account_name }}</td>
          <td *ngIf="!ledger.editing">{{ ledger.description }}</td>
          <td *ngIf="!ledger.editing">{{ ledger.category == 'credit' ? (ledger.amount | currency: 'USD':'symbol':'1.2-2') : '' }}</td>
          <td *ngIf="!ledger.editing">{{ ledger.category == 'debit' ? (ledger.amount | currency: 'USD':'symbol':'1.2-2') : '' }}</td>
          <td colspan="6" *ngIf="ledger.editing">
            <h5 class="font-italic">Editing Adjustment</h5>
            <form novalidate>
              <app-ledger-adjustment-form [ledger]="ledger"></app-ledger-adjustment-form>
              <div class="form-group text-center">
                <button type="button" class="btn btn-primary" (click)="updateAdjustment(ledger)">Update</button>
                &nbsp;
                <button type="button" class="btn btn-outline-secondary" (click)="ledger.editing = false">Cancel</button>
              </div>
            </form>
          </td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td class="font-weight-bold">Totals</td>
          <td>{{ creditSum | currency: 'USD':'symbol':'1.2-2' }}</td>
          <td>{{ debitSum | currency: 'USD':'symbol':'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
    <div class="form-group text-right" *ngIf="creditSum != debitSum || creditSum == 0 || debitSum == 0">
      <h6 class="text-danger" *ngIf="creditSum != debitSum">Credit and Debit amounts are not equal.</h6>
      <h6 class="text-warning" *ngIf="creditSum == debitSum && (creditSum == 0 || debitSum == 0)">Credit and debit must be above zero.</h6>
    </div>
    <div class="form-group p-4 text-center" *ngIf="creditSum == debitSum && creditSum > 0">
      <button type="button" class="btn btn-primary" (click)="createAdjustments()" [disabled]="creatingAdjustments">
        {{ creatingAdjustments ? 'Creating Adjustments' : 'Create Adjustments' }}<span *ngIf="creatingAdjustments">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
      </button>
    </div>
  </div>
  <div class="py-5"></div>
</div>
<div class="my-5 py-5"></div>
